import { call, put } from 'redux-saga/effects';
import moment from 'moment';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { signDocxSuccessful, signDocxFailed, uploadSignFile } from '../actions';
import processError from '../../../utils/processError';
import { BACKEND_URL_V2 } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import sign from './sign';
import { nameBySave } from '../../../utils/utils';
import { dateFormatter } from '../../../utils/formatters';

export default function* signDocx(action) {
  try {
    const { cert, document, file } = action.payload;
    const explicitBlob = new Blob([file[0]], { type: file[0].type });
    const signature = yield sign(cert, explicitBlob, true);
    if (typeof signature === 'string') {
      throw new Error(signature);
    }
    const fileFormData = new FormData();
    const templateName = document && document.notification_template && document.notification_template.name
      ? document.notification_template.name
      : document.id;
    const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.docx`);

    fileFormData.append('model_type', 'document');
    fileFormData.append('model_id', document.id);
    fileFormData.append('collection_name', 'signed');
    fileFormData.append('name', name);
    fileFormData.append('file', explicitBlob, nameBySave(name));
    fileFormData.append('sign_file', signature, nameBySave(`${name}.sig`));
    const fileUploadPromise = yield put(uploadSignFile(fileFormData));
    const fileUpload = yield fileUploadPromise;
    //
    // const signatureUploadPromise = yield put(uploadFile(sigFormData));
    // const signatureUpload = yield signatureUploadPromise;
    if (!fileUpload) {
      throw new Error(`Фаил «${name}.sig» не сохранен`);
    }

    if (typeof signature !== 'string') {
      yield put(signDocxSuccessful(signature));
      yield call(resolveActionPromise(action, signature));
      return signature;
    }
    yield put(signDocxFailed(false));
    yield call(rejectActionPromise(action, false));
    return false;
  } catch (e) {
    yield put(signDocxFailed(false));
    yield call(rejectActionPromise(action, e && e.message ? e.message : ''));
    yield processError(e);
    return false;
  }
}
